<template>
    <div ref="gaugeChartContainer">
        <highcharts v-if="Object.keys(chartData).length" :options="chartData" ref="gaugeChart" />
    </div>
</template>
<script>
export default {
    name: "GaugeChart",
    data() {
        return {
            chartData: {}
        }
    },
    props: {
        rawData: {
            type: Object,
            required: true
        }
    },
    mounted() {
        this.plotChart();
        this.resizeObserver = new ResizeObserver(() => {
            this.resizeChart();
        });
        this.resizeObserver.observe(this.$refs.gaugeChartContainer);
    },
    beforeDestroy() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    },
    methods: {
        resizeChart() {
            if (this.$refs.gaugeChart.chart) {
                this.$refs.gaugeChart.chart.reflow();
            }
        },
        plotChart() {
            let self = this;
            this.chartData = {
                chart: {
                    type: 'pie',
                    height: 150,
                    width: 200,
                },
                title: {
                    text: ''
                },
                exporting: {
                    enabled: false,
                },
                plotOptions: {
                    pie: {
                        innerSize: '80%',
                        startAngle: -90,
                        endAngle: 90,
                        dataLabels: {
                            enabled: false,
                        }
                    }
                },
                credits: {
                    enabled: false
                },
                tooltip: {
                    shared: true,
                    borderWidth: 1,
                    borderColor: "rgba(212, 212, 212, 1)",
                    shadow: {
                        color: "#d6d6d6",
                        opacity: 0.1,
                        width: 10,
                    },
                    borderRadius: 15,
                    backgroundColor: "#ffffff",
                    style: {
                        fontSize: "16px"
                    },
                    padding: 10,
                    formatter: function () {
                        return this.point.name + ': <b>' + this.y.toFixed(2) + '%' + '</b>';
                    }
                },
                series: [{
                    name: 'WordGauge',
                    data: [
                        {
                            name: 'Negative',
                            y: self.rawData.negative_score,
                            color: {
                                linearGradient: {
                                    x1: 0,
                                    y1: 0,
                                    x2: 0,
                                    y2: 1
                                },
                                stops: [
                                    [0, '#FA1919'],
                                    [1, '#8F1616']
                                ]
                            }
                        },
                        {
                            name: 'Positive',
                            y: self.rawData.positive_score,
                            color: {
                                linearGradient: {
                                    x1: 0,
                                    y1: 0,
                                    x2: 0,
                                    y2: 1
                                },
                                stops: [
                                    [0, '#009688'],
                                    [1, '#01695C']
                                ]
                            }
                        },
                    ]
                }]
            }

        },
    }
}
</script>